import {
  type IoConfig,
  type NsHostTypeSlotId,
  type WithIoConfig,
  type WithNsHostTypeSlot,
} from '@blaze-runtime/engine-domain';

import { registerElementDefinition } from '../../services/element-definitions.service';

import { NavSidebarComponent } from './nav-sidebar.component';

// Extend the CanvasElementDefinitions type
declare module '@blaze-runtime/engine-domain' {
  interface CanvasElementDefinitions {
    navSidebar: NavSidebarDef;
  }
}

export const NAV_SIDEBAR_HOST_SLOT: NsHostTypeSlotId = 'nsHostType:Sidebar';
export type NavSidebarDef = WithNsHostTypeSlot & WithIoConfig;

registerElementDefinition({
  type: 'navSidebar',
  componentType: NavSidebarComponent,
  isListed: true,
  name: 'Navigation Sidebar',
  width: { mode: 'auto' },
  height: { mode: 'full' },
  slots: {
    ids: [NAV_SIDEBAR_HOST_SLOT],
    [NAV_SIDEBAR_HOST_SLOT]: {
      children: [],
      hosting: {},
    },
  },
  ioConfig: getIoConfig(),
  tags: ['Nav Menu', 'Sidebar'],
  groups: ['navigation'],
  version: 1,
});

function getIoConfig(): IoConfig {
  return {
    inputs: [
      {
        name: 'visible',
        bindingDefs: [{ property: 'visible', label: 'Is Visible', dataType: 'Boolean' }],
      },
    ],
    outputs: [],
  };
}
